import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';

import { ApiError, AuthService, BaseForm, BaseFormService, MessageService } from '../../../core';

import { Cidade } from '../cidade';
import { CidadeCrudHttpService } from '../services';
import { cidadeClassificacoes } from '../classificacao-abc';
import { Estado, EstadoCrudHttpService } from '../../estado';

@Component({
    selector: 'sgt-cidade-form',
    templateUrl: './cidade-form.component.html'
})
export class CidadeFormComponent implements BaseForm<Cidade>, OnInit {
    entity: Cidade;
    editMode: boolean;
    @ViewChild('form') form: NgForm;
    estados: Estado[] = [];
    classificacoes = cidadeClassificacoes;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private messageService: MessageService,
                private baseFormService: BaseFormService,
                private cidadeCrudHttpService: CidadeCrudHttpService,
                private estadoCrudHttpService: EstadoCrudHttpService) { }

    ngOnInit() {
        this.baseFormService.getIdParam(this.activatedRoute).then(id => {
            if (!id) {
                this.insert();
            } else {
                this.edit(id);
            }
        })
    }

    load(id: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.cidadeCrudHttpService.load(id)
                .subscribe(
                    entity => {
                        this.entity = entity;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar a linha do item', error);
                        this.cancel();
                        reject();
                    }
                );
        });
    }

    async insert() {
        this.editMode = false;
        this.entity = new Cidade(null);
        this.entity.cadastroManual = true;

        await this.searchEstados();
        this.setEstadoExterior();
    }

    async edit(id: number) {
        this.editMode = true;
        await this.load(id);

        if (this.entity?.cadastroManual) {
            this.searchEstados();
        }
    }


    save() {
        try {
            this.baseFormService.save<Cidade>(this.entity, this.form, this.editMode, this.cidadeCrudHttpService)
                .then(entity => {
                    this.messageService.success('', 'Cidade salva com sucesso');
                    this.afterSave(entity);
                })
                .catch(error => {});
        } catch (error) {
            console.error(error);
        }
    }

    afterSave(entity: Cidade) {
        this.cancel();
    }

    cancel() {
        this.baseFormService.cancel(this.activatedRoute);
    }

    /** Pesquisa todos os estados */
    private searchEstados(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.estadoCrudHttpService.search()
                .subscribe(
                    entities => {
                        this.estados = entities;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message,  'Erro ao pesquisar os estados', error);
                        reject();
                    }
                );
        });
    }

    /** Seta o extado da cidade */
    private setEstado(estado: Estado) {
        this.entity.estado = estado ?? null;
        this.entity.idEstado = estado?.id ?? null;
    }

    /** Seta o extado da cidade igual a Exterior */
    private setEstadoExterior() {
        const estadoEx = this.estados?.find(estadoFilter => estadoFilter.uf === 'EX');
        this.setEstado(estadoEx);
    }

    /** Ao alterar o estado */
    onChangeEstado(idEstado: number) {
        const estado = this.estados?.find(estadoFilter => estadoFilter.id === idEstado);
        this.setEstado(estado);
    }
}
